/**
 * **Billing** — which plan the visit bills on, with make-one-here (moved out
 * of the visit popover at step 8). Props only.
 */
import { BILLING_PLAN_KIND_LABELS, type QuoteBillingPlanView } from '@rowted/shared'
import { MenuSelect } from '../../components/menu-select.js'
import { FieldShell } from '../../components/fields.js'
import { BILLING_PLAN_HINT, BILLING_SECTION, OPEN_BILLING_TAB } from '../copy.js'

export function BillingField({ plans, value, onChange, onCreatePlan, onOpenBilling }: {
  plans: QuoteBillingPlanView[]
  value: string | null
  onChange: (planId: string | null) => void
  /** Make a plan from the menu and put this visit on it. */
  onCreatePlan?: (name: string) => Promise<void>
  /** cb-07's `Open the Billing tab ›` — absent where there is no Billing tab to open. */
  onOpenBilling?: () => void
}) {
  return (
    <section data-billing-field="" className="flex flex-col gap-2 border-t border-line-soft pt-4">
    <b className="text-[14px] font-bold text-text">{BILLING_SECTION}</b>
    <FieldShell
      label="Billing plan"
      hint={value ? BILLING_PLAN_HINT : 'Every visit needs one before the quote can be sent.'}
    >
      <MenuSelect
        size="field"
        label="Billing plan"
        value={value}
        onChange={onChange}
        clearable
        clearLabel="No plan yet"
        options={plans.map((plan) => ({
          value: plan.id,
          label: plan.name,
          detail: BILLING_PLAN_KIND_LABELS[plan.kind],
        }))}
        createThing="billing plan"
        onCreate={onCreatePlan
          ? (typed) => { void onCreatePlan(typed) }
          : undefined}
      />
    </FieldShell>
    {onOpenBilling && (
      <button type="button" onClick={onOpenBilling}
        className="self-start text-[12.5px] font-semibold text-accent hover:text-accent-dark">
        {OPEN_BILLING_TAB}
      </button>
    )}
    </section>
  )
}
